import axios from "axios";
import config from "../config.json";

export const isAuthenticated = () => {
  // Add your authentication logic here
  // For example, check if a token exists in localStorage
  return !!localStorage.getItem("token");
};

export const login = async (email, password) => {
  // Save the token to localStorage
  try {
    const response = await axios.post(`${config.apiBaseUrl}/login`, {
      email: email,
      password: password,
    });
    localStorage.setItem("token", response.data.access_token);
    window.location.href = "/";
    return {
      status: "success",
      message: "Login successful",
    };
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return {
        status: "error",
        message: error.response.data.detail,
      };
    }
    console.error("Error during login:", error);
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};

export const signup = async (email, password) => {
  try {
    await axios.post(`${config.apiBaseUrl}/signup`, {
      email: email,
      password: password,
    });
    window.location.href = "/";
    return {
      status: "success",
      message: "Signup successful",
    };
  } catch (error) {
    if (error.response && error.response.status === 400) {
      return {
        status: "error",
        message: error.response.data.detail,
      };
    }
    console.error("Error during signup:", error);
  }
};
